import { Controller } from "@hotwired/stimulus"

// Adds extra participants (partner, group members) to a visit: type to find
// an existing client, pick one, and a chip with a hidden input appears.
export default class extends Controller {
  static targets = ["input", "results", "list", "template"]
  static values = { url: String, name: String, emptyText: String }

  connect() {
    this.timer = null
    this.onClickOutside = (event) => { if (!this.element.contains(event.target)) this.hideResults() }
    document.addEventListener("click", this.onClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.onClickOutside)
    clearTimeout(this.timer)
  }

  search() {
    const query = this.inputTarget.value.trim()
    clearTimeout(this.timer)
    if (query.length < 2) { this.hideResults(); return }
    this.timer = setTimeout(() => this.fetch(query), 250)
  }

  async fetch(query) {
    try {
      const response = await fetch(`${this.urlValue}?query=${encodeURIComponent(query)}`, { headers: { Accept: "application/json" } })
      if (!response.ok) return this.hideResults()
      const people = (await response.json()).filter(p => p.id && !this.chosenIds().includes(String(p.id)))
      this.render(people)
    } catch {
      this.hideResults()
    }
  }

  render(people) {
    this.resultsTarget.innerHTML = ""
    if (people.length === 0) {
      this.resultsTarget.innerHTML = `<div class="px-3 py-2 text-sm opacity-60">${this.emptyTextValue}</div>`
    }
    people.forEach(person => {
      const name = [person.first_name, person.last_name].filter(Boolean).join(" ") || person.email || person.phone_number
      const button = document.createElement("button")
      button.type = "button"
      button.className = "block w-full text-left px-3 py-2 text-sm hover:bg-base-200"
      button.textContent = name + (person.email || person.phone_number ? ` · ${person.email || person.phone_number}` : "")
      button.addEventListener("click", () => this.add(person.id, name))
      this.resultsTarget.appendChild(button)
    })
    this.resultsTarget.classList.remove("hidden")
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden")
  }

  add(id, name) {
    const chip = this.templateTarget.content.firstElementChild.cloneNode(true)
    chip.querySelector("[data-role='name']").textContent = name
    const input = chip.querySelector("input")
    input.value = id
    input.name = this.nameValue
    this.listTarget.appendChild(chip)
    this.inputTarget.value = ""
    this.hideResults()
  }

  remove(event) {
    event.currentTarget.closest("[data-participant]").remove()
  }

  chosenIds() {
    return Array.from(this.listTarget.querySelectorAll("input")).map(i => i.value)
  }
}
